import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { SiteSettingsForServerAdminProps } from '../site-settings/ReactSiteSettingsForServerAdmin';
import React = require('react');
import { SessionServerSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { useSelector } from '../../utils';

export type PrepConductorSectionProps = SiteSettingsForServerAdminProps<'schedulingFlowsEnabled'>;

export function PrepConductorSection(props: PrepConductorSectionProps) {
  const flowsOnServerEnabled = useSelector(SessionServerSelectors.isFlowOnServerEnabled);

  return <SettingsSection title={Messages.prepConductor()}
                          testId={'prep-conductor-setting-section'}
                          description={Messages.flowsOnSiteDetails()} >
        <FormikCheckbox name={'settings.schedulingFlowsEnabled'}
                          label={Messages.allowFlowsOnSite()}
                          testId={'allow-flows-on-site-checkbox'}
                          disabled={!flowsOnServerEnabled}/>
        </SettingsSection>;
}

/* for registering the component in settings registry */
export const PrepConductorSpecs = componentRegistryEntry({
  name: 'PrepConductorSection',
  component: PrepConductorSection
});
